import * as Services from "../../../Service/Service"
import * as Url from '../../../Service/Url';

export const getCarrierData = async() => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_CARRIER, token)
  return res;
};

export const getFileTypeData = async() => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_FILE_TYPE, token)
  return res;
};

export const GetMedicalCarrierData = async(clientId, userId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_MEDICAL_CARRIER_DATA + `ClientID=${clientId}&UserId=${userId}`, token)
  return res;
};

export const SaveMedicalCarrierData = async(payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.SAVE_MEDICAL_CARRIER_DATA, payload, token)
  return res;
};

export const UpdateMedicalCarrierData = async(payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.UPDATE_MEDICAL_CARRIER_DATA, payload, token);
  return res;
};

export const DeleteMedicalCarrierData = async(payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_MEDICAL_CARRIER_DATA + payload.MedCarID, '', token);
  return res;
};


